import { render, staticRenderFns } from "./PlaceFilters.vue?vue&type=template&id=3e9906c4&"
import script from "./PlaceFilters.vue?vue&type=script&lang=ts&"
export * from "./PlaceFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports